import { Button, Icon, IconTooltip } from "@growtherapy/sprout-ui";
import { CLIENT_ACCOUNT_PAUSED_TOOLTIP_TEXT } from "./constants";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

export function AddAppointmentButton({
  onClickHandler,
  isClientUserAccountPaused,
  buttonClassName,
}: {
  onClickHandler: () => void;
  isClientUserAccountPaused: boolean;
  buttonClassName?: string;
}): JSX.Element {
  return (
    <>
      <Button
        onClick={onClickHandler}
        use="secondary"
        disabled={isClientUserAccountPaused}
        className={buttonClassName}
      >
        Add appointment
        <Icon icon={faPlus} />
      </Button>
      {isClientUserAccountPaused && (
        <IconTooltip
          className="max-w-[256px] normal-case"
          iconClassName="text-lilac-700 ml-2"
          iconSize="sm"
          placement="right"
          text={CLIENT_ACCOUNT_PAUSED_TOOLTIP_TEXT}
        />
      )}
    </>
  );
}
